<template>
  <tr :class="rowClass">
    <td class="cursor-pointer">
      <span class="bold">{{ section.systemName }}</span>
    </td>
    <td>
      <action-button icon="fa-pen" @click="editClicked"></action-button>
      <action-button icon="fa-trash" @click="deleteClicked"></action-button>
    </td>
  </tr>
</template>
<script>
import tableRow from "@/mixins/tableRow";

export default {
  mixins: [tableRow],
  props: ["section"],
  methods: {
    deleteClicked: function() {
      this.$emit("delete", this.section.id);
    },
    editClicked: function() {
      this.$emit("edit", this.section.id);
    },
  },
  emits: ["delete", "edit"],
};
</script>
